import React from "react";
import Checkbox from "../../../../../common/components/shared/checkbox/checkbox";
import Row from "../../../../../common/components/shared/row/row";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import { storesContext } from "../../../../../common/stores/stores";
import i18n from "../../../../../i18n/i18n";
import { ITicketStore } from "../../../../stores/ticketStore";

export default class CargoSection extends React.Component {
    static contextType = storesContext;

    render() {
        const ticketStore = this.context.ticketStore as ITicketStore;

        return (
            <div className="section">
                <div className="section-header">
                    {i18n.t("transportation.ticket.details.cargo.header")}
                </div>
                <div className="section-content">
                    <Row class="flex-type gap-30">
                        <TextInput
                            label={i18n.t("transportation.ticket.details.cargo.properties.cargoDesc")}
                            validatedValue={ticketStore.cargoDesc}
                            testId="cargo-desc"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.ticket.details.cargo.properties.weight")}
                            validatedValue={ticketStore.weight}
                            testId="weight"
                            unit="kg"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.ticket.details.cargo.properties.height")}
                            validatedValue={ticketStore.height}
                            testId="height"
                            unit="m"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.ticket.details.cargo.properties.width")}
                            validatedValue={ticketStore.width}
                            testId="width"
                            unit="m"
                            offAutocomplete
                        />
                        <TextInput
                            label={i18n.t("transportation.ticket.details.cargo.properties.length")}
                            validatedValue={ticketStore.length}
                            testId="length"
                            unit="m"
                            offAutocomplete
                        />
                        <Checkbox
                            label={i18n.t("transportation.ticket.details.cargo.properties.securingDeclaration")}
                            validatedValue={ticketStore.securingDeclaration}
                            testId="securing-declaration"
                        />
                    </Row>
                </div>
            </div>
        );
    }
}